var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderViewIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 27.4H12.4V13.7111H19.6V27.4ZM22 27.4V13.7111H28V26.1556C28 26.4856 27.8736 26.8021 27.6485 27.0355C27.4235 27.2689 27.1183 27.4 26.8 27.4H22ZM10 27.4H5.2C4.88174 27.4 4.57652 27.2689 4.35147 27.0355C4.12643 26.8021 4 26.4856 4 26.1556V13.7111H10V27.4ZM28 11.2222H4V6.24444C4 5.9144 4.12643 5.59787 4.35147 5.36449C4.57652 5.13111 4.88174 5 5.2 5H26.8C27.1183 5 27.4235 5.13111 27.6485 5.36449C27.8736 5.59787 28 5.9144 28 6.24444V11.2222Z",
    fill: "#1173F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderViewIcon);
export default __webpack_public_path__ + "static/media/calender-view-icon.5767d7d22025e0eeff934b07ed2113ba.svg";
export { ForwardRef as ReactComponent };